<template>
  <div class="py-3">
    <page-loading v-if="!item && !loadError" />
    <b-alert v-if="loadError" show variant="danger">{{ loadError }}</b-alert>
    <b-alert v-if="saveError" show variant="danger">{{ saveError }}</b-alert>
    <page-title v-if="item" :title="pageTitle" />
    <hr />
    <div v-if="item" class="mt-3">
      <application-user-fields :item="item" v-on:submit="onSubmit" v-on:cancel="onCancel">
        <template v-slot:save>Save</template>
      </application-user-fields>
    </div>
    <hr />
    <b-button type="button" @click="onSpoof">Spoof</b-button>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ApplicationUserEdit",
  props: ['id'],
  data() {
    return {
      item: null,
      loadError: null,
      saveError: null,
      isSaving: false
    };
  },
  computed: {
    pageTitle: function () {
      return 'User: ' + this.item.userName;
    }
  },
  methods: {
    load: function () {
      let url = '/api/applicationUser/' + this.id;

      axios
        .get(url)
        .then(response => {
          console.log(response);

          // TODO: Check for 200?

          this.item = response.data;
        })
        .catch(error => {
          this.loadError = "Unable to load this user. Please try again.";
        });
    },
    onSpoof: function (evt) {
      axios.post('/api/account/spoofLogin',
      {
        "userId": this.id
      })
      .then(response => {
        if (response.status == 200) {
          if (response.data.requiresVerificationCode) {
            this.logInUsesTFA = true;
            return;
          }

          axios.defaults.headers.common['Authorization'] = "Bearer " + response.data.jwtToken;
          this.$root.$data.authenticatedUser.username = response.data.userName;
          this.$root.$data.authenticatedUser.id = response.data.id;
          this.$root.$data.authenticatedUser.roles = response.data.roles;

          localStorage.setItem('jwt', response.data.jwtToken);
          localStorage.setItem('username', response.data.userName);
          localStorage.setItem('id', response.data.id);
          localStorage.setItem('roles', JSON.stringify(response.data.roles));

          this.$router.push('/');
        }
      })
      .catch(error => {
        console.log(error);
      });
    },
    onCancel(evt) {
      this.$router.push('/applicationUser');
    },
    onSubmit(evt) {
      this.saveError = null;
      if (this.isSaving) return;
      this.isSaving = true;
      axios.put('/api/applicationUser/' + this.id + '/profile', {
        firstName: this.item.firstName,
        lastName: this.item.lastName
      }).then(response => {
        this.item = response.data;
        this.$bvModal.msgBoxOk('User name saved successfully.', { title: 'Saved' });
      }).catch(error => {
        this.saveError = error.response && error.response.status === 403
          ? 'You do not have permission to edit users.'
          : 'Unable to save the user. Please check the names and try again.';
      }).finally(() => { this.isSaving = false; });
    }    
  },
  mounted () {
    this.load();
    // Use this instead of the previous line to test the "Loading" bar
    //window.setTimeout(this.load, 3000);
  }
};
</script>